import { fromJS } from 'immutable';
import { get } from 'lodash';
import {
  SET_PENDING_CLAIMS,
  SET_SEARCH_PENDING_CLAIMS,
} from 'containers/PendingClaimsPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const pendingClaimsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PENDING_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case SET_SEARCH_PENDING_CLAIMS:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default pendingClaimsReducer;
